import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  currentSelectedProperty: {},
  currentUser: {
    orgs: [],
  },
  selectedUser: {},
  userId: null,
  userSystemRole: '',
  userEditableProperties: [],
  userViewableProperties: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
